var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{staticClass:"form-control form-control-sm",attrs:{"value":_vm.value,"config":_vm.options},on:{"dp-change":function($event){return _vm.$emit('input', $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }